import { render, staticRenderFns } from "./DesireList.vue?vue&type=template&id=cf664c26&scoped=true&"
import script from "./DesireList.vue?vue&type=script&lang=js&"
export * from "./DesireList.vue?vue&type=script&lang=js&"
import style0 from "./DesireList.vue?vue&type=style&index=0&id=cf664c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf664c26",
  null
  
)

export default component.exports